var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-segment"},[_c('client-only',[(_vm.embedType)?_c(_vm.embedType.component,{tag:"component",attrs:{"url":_vm.segmentData.url,"title":_vm.segmentData.title,"caption":_vm.segmentData.caption}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }